<i18n
  src="@/locales/views/packing_house/process/show_process.yml"
  lang="yaml"
></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      name="ph_process_harvested_batches_list_processes_path"
      :params="{
        packing_house_id: this.packing_house_id
      }"
    ></go-back-link>
    <bread-crumbs
      :labels="[module_name, packing_house_process.name]"
    ></bread-crumbs>

    <div class="bg-white shadow overflow-hidden sm:rounded-md">
      <ul role="list" class="divide-y divide-gray-200">
        <li>
          <div href="#" class="block hover:bg-gray-50 cursor-pointer" @click.prevent="goToListHarvestedBatches">
            <div class="px-4 py-4 sm:px-6">
              <div class="flex items-center justify-between">
                <p class="text-sm font-medium text-gray-900 truncate">
                  {{ $t("labels.harvested_batches_title") }}
                </p>
                <div class="ml-2 flex-shrink-0 flex">
                  <a class="link" @click.prevent="goToListHarvestedBatches"
                    ><i class="fa-solid fa-pen"></i
                    ><span class="space-icon"></span
                    >{{ $t("labels.manage_link") }}</a
                  >
                </div>
              </div>
              <div class="mt-2 sm:flex sm:justify-between">
                <div class="sm:flex">
                  <p class="flex items-center text-sm text-gray-500">
                    <i
                      class="fa-solid fa-crate-apple flex-shrink-0"
                      aria-hidden="true"
                    />
                    <span class="space-icon"></span>
                    {{ packing_house_process.num_harvested_batches }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/harvested_batches/show_process.js";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  name: "ShowProcess",
  components: { BreadCrumbs },
  data() {
    return {
      packing_house_process: {}
    };
  },
  props: {
    packing_house_id: {
      required: true
    },
    packing_house_process_id: {
      required: true
    }
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id
        }
      }).then(() => this.fetchPackingHouseProcess());
    });
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      let response = await Requester.fetchPackingHouseProcess(
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    goToListHarvestedBatches: function () {
      this.$router.push({
        name: "ph_process_harvested_batches_list",
        params: {
          packing_house_process_id: this.packing_house_process_id,
          packing_house_id: this.packing_house_id
        }
      });
    }
  }
};
</script>
